import { DEFAULT_LANGUAGE, type SupportedLanguage } from './language';

export type CoreTranslationDictionary = Record<string, any>;

type TranslationLoader = () => Promise<CoreTranslationDictionary>;

const CORE_TRANSLATION_LOADERS: Record<SupportedLanguage, TranslationLoader> = {
  'zh-CN': () => import('./translations/zh-core').then((module) => module.default as CoreTranslationDictionary),
  'zh-TW': () => import('./translations/zh-TW-core').then((module) => module.default as CoreTranslationDictionary),
  en: () => import('./translations/en-core').then((module) => module.default as CoreTranslationDictionary),
  ja: () => import('./translations/ja-core').then((module) => module.default as CoreTranslationDictionary),
  ko: () => import('./translations/ko-core').then((module) => module.default as CoreTranslationDictionary),
};

export const loadCoreTranslations = async (language: SupportedLanguage): Promise<CoreTranslationDictionary> => {
  const loader = CORE_TRANSLATION_LOADERS[language] ?? CORE_TRANSLATION_LOADERS[DEFAULT_LANGUAGE];
  return loader();
};

export const getCoreTranslationLoader = (language: SupportedLanguage): TranslationLoader =>
  CORE_TRANSLATION_LOADERS[language] ?? CORE_TRANSLATION_LOADERS[DEFAULT_LANGUAGE];

export const loadDefaultCoreTranslations = (): Promise<CoreTranslationDictionary> =>
  CORE_TRANSLATION_LOADERS[DEFAULT_LANGUAGE]();
